export default "__VITE_ASSET__D2FuLC45__"